import { debounce } from 'lodash';

const SELECTOR = '.global-group';

export default function () {
    const element = document.querySelector(SELECTOR);

    if (!element) {
        return;
    }

    const setGroupHeight = () => {
        const { height } = element.getBoundingClientRect();

        document.documentElement.style.setProperty(
            '--global-header-height', `${height}px`
        );
    }

    window.addEventListener('resize', debounce(setGroupHeight, 250));

    const alerts = document.querySelector('.global-alerts');

    if (alerts) {
        new MutationObserver(setGroupHeight).observe(alerts, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style'],
        });
    }

    setGroupHeight();
}
